/*********************************
 * PRODUCT SECTIONS RENDER
 * Handles dynamic product switching without page reload
 *********************************/
(function() {
  'use strict';

  // Prevent multiple initializations
  if (window.ProductSectionsRender) return;
  window.ProductSectionsRender = true;

  /*********************************
   * CONFIG – DYNAMIC SELECTORS
   *********************************/
  const SELECTORS = {
    // Product section selectors
    productSection: '.section-product--primary',
    productWrapper: '.js-product',
    shopifySection: '.shopify-section',
    
    // Recommendations
    recommendations: '.product-recommendations',
    recommendationsScroller: '.js-scroll-container',
    
    // Reviews
    reviews: '#section-reviews',
    
    // Sliders
    sliderProduct: '.js-slider-product',
    sliderThumbs: '.js-slider-thumbs',
    sliderZoom: '.js-slider-zoom',
    
    // Product grouping
    groupWrapper: '.product-grouping-wrapper',
    groupItem: '.product-group-item',
    
    // Form elements
    selectGlobal: '.js-select-global',
    selectCustom: '.js-select-custom select',
    radioColor: '.js-radio-color input',
    
    // Lazy load
    lazyload: '.lazyload',
    lazyloadImg: 'img.lazyload, img[data-src]',
    lazyloadBg: '[data-bg]'
  };

  /*********************************
   * HELPER: Get Product Section
   *********************************/
  function getProductSection() {
    return document.querySelector(SELECTORS.productSection) || 
           document.querySelector(SELECTORS.productWrapper) ||
           document.querySelector('[id^="shopify-section-"][id*="product"]');
  }

  /*********************************
   * HELPER: Get Section Container
   *********************************/
  function getSectionContainer(element) {
    if (!element) return null;
    return element.closest(SELECTORS.shopifySection) || element.closest('[id^="shopify-section-"]');
  }

  /*********************************
   * INIT PRODUCT GROUP CLICKS
   *********************************/
  function attachProductClickListener() {
    const wrapper = document.querySelector(SELECTORS.groupWrapper);
    if (!wrapper) return;

    wrapper.removeEventListener('click', handleClick);
    wrapper.addEventListener('click', handleClick);
  }

  /*********************************
   * FETCH & REPLACE SECTIONS
   *********************************/
  function fetchAndReplaceSections(url, pushState = true) {
    const productSection = getProductSection();
    const productShopifySection = getSectionContainer(productSection);
    
    if (productShopifySection) {
      productShopifySection.style.opacity = '0.5';
      productShopifySection.style.pointerEvents = 'none';
    }

    fetch(url, { credentials: 'same-origin' })
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        destroySliders();
        jQuery('.zoomContainer').remove();

        replaceProductSection(doc);
        replaceReviewsSection(doc);
        updateProductRecommendations(doc);
        updateProductMetafields(doc);
        updateShopifyProduct(doc);
        updateSpin360Globals(doc);

        document.title = doc.title;
        if (pushState) {
          history.pushState({ url }, '', url);
        }

        setTimeout(() => {
          reInitProductPage();
        }, 100);
      })
      .catch(err => {
        console.error('Section update failed:', err);
        if (productShopifySection) {
          productShopifySection.style.opacity = '1';
          productShopifySection.style.pointerEvents = 'auto';
        }
      });
  }

  /*********************************
   * REPLACE PRODUCT SECTION
   *********************************/
  function replaceProductSection(doc) {
    const newProductSection = doc.querySelector(SELECTORS.productSection) || 
                              doc.querySelector(SELECTORS.productWrapper);
    
    if (!newProductSection) return;
    
    const newShopifySection = getSectionContainer(newProductSection) || 
                              doc.querySelector('[id^="shopify-section-"][id*="product-main"]') ||
                              doc.querySelector('[id^="shopify-section-"][id*="product"]');
    
    const currentProductSection = getProductSection();
    const currentShopifySection = getSectionContainer(currentProductSection) ||
                                  document.querySelector('[id^="shopify-section-"][id*="product-main"]') ||
                                  document.querySelector('[id^="shopify-section-"][id*="product"]');

    if (newShopifySection && currentShopifySection) {
      currentShopifySection.replaceWith(newShopifySection);
      executeSectionScripts(newShopifySection);
    } else if (newProductSection && currentProductSection) {
      currentProductSection.replaceWith(newProductSection);
      executeSectionScripts(newProductSection);
    }
  }

  /*********************************
   * REPLACE REVIEWS SECTION
   *********************************/
  function replaceReviewsSection(doc) {
    const newReviews = doc.querySelector(SELECTORS.reviews);
    const currentReviews = document.querySelector(SELECTORS.reviews);

    if (newReviews && currentReviews) {
      currentReviews.replaceWith(newReviews);
      executeSectionScripts(newReviews);
    }
  }

  /*********************************
   * UPDATE PRODUCT METAFIELDS
   *********************************/
  function updateProductMetafields(doc) {
    const scripts = doc.querySelectorAll('script');
    scripts.forEach(script => {
      if (script.textContent && 
          (script.textContent.includes('VARIANT_METAFIELDS') || 
           script.textContent.includes('PRODUCT_METAFIELDS'))) {
        try {
          if (script.textContent.includes('window.VARIANT_METAFIELDS = []')) {
            window.VARIANT_METAFIELDS = [];
          }
          eval(script.textContent);
        } catch (e) {
          console.warn('Failed to update product metafields:', e);
        }
      }
    });
  }

  /*********************************
   * UPDATE PRODUCT RECOMMENDATIONS
   *********************************/
  function updateProductRecommendations(doc) {
    const $ = jQuery;
    
    const newRecommendationsSection = doc.querySelector(SELECTORS.recommendations);
    if (!newRecommendationsSection) {
      console.warn('No recommendations section found in new document');
      return;
    }

    const newProductId = newRecommendationsSection.dataset.productId;
    const limit = newRecommendationsSection.dataset.limit || 10;

    if (!newProductId) {
      console.warn('No product ID found for recommendations');
      return;
    }

    const currentRecommendations = document.querySelector(SELECTORS.recommendations);
    const currentRecommendationsWrapper = currentRecommendations ? 
                                          (getSectionContainer(currentRecommendations) || 
                                           document.querySelector('[id*="product-recommendations"]') ||
                                           currentRecommendations.parentElement) : 
                                          document.querySelector('[id*="product-recommendations"]');
    
    if (!currentRecommendationsWrapper) {
      console.warn('No recommendations wrapper found in current document');
      return;
    }

    const timestamp = Date.now();
    const requestUrl = `/recommendations/products?section_id=product-recommendations&limit=${limit}&product_id=${newProductId}&_=${timestamp}`;

    fetch(requestUrl, { 
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        'Cache-Control': 'no-cache'
      }
    })
      .then(res => res.text())
      .then(html => {
        const container = document.createElement('div');
        container.innerHTML = html;

        let links = '';
        $(container).find('.scroll-item').each(function() {
          const linkUrl = $(this).find('a').attr('href');
          if (linkUrl && (linkUrl.includes('/gift-wrap') || linkUrl.includes('/personalized-fee'))) {
            $(this).remove();
            return;
          }

          if (links.includes(linkUrl)) {
            $(this).remove();
          } else {
            links += linkUrl;
          }
        });

        const newContent = container.querySelector(SELECTORS.recommendations);
        
        if (newContent) {
          newContent.dataset.productId = newProductId;
          
          const currentSection = document.querySelector(SELECTORS.recommendations);
          
          if (currentSection) {
            currentSection.replaceWith(newContent);
          } else if (currentRecommendationsWrapper) {
            currentRecommendationsWrapper.innerHTML = '';
            currentRecommendationsWrapper.appendChild(newContent);
          }
        } else {
          const currentSection = document.querySelector(SELECTORS.recommendations);
          if (currentSection) {
            currentSection.innerHTML = '';
            currentSection.dataset.productId = newProductId;
          }
        }

        setTimeout(() => {
          initRecommendationsScroller();
          initLazyLoad();
        }, 100);
      })
      .catch(err => {
        console.warn('Failed to load product recommendations:', err);
      });
  }

  /*********************************
   * DESTROY EXISTING SLIDERS
   *********************************/
  function destroySliders() {
    const $ = jQuery;
    
    try {
      const $sliderProduct = $(SELECTORS.sliderProduct);
      const $sliderThumbs = $(SELECTORS.sliderThumbs);

      if ($sliderProduct.length && $sliderProduct.hasClass('slick-initialized')) {
        $sliderProduct.slick('unslick');
      }

      if ($sliderThumbs.length && $sliderThumbs.hasClass('slick-initialized')) {
        $sliderThumbs.slick('unslick');
      }
    } catch (e) {
      console.warn('Error destroying sliders:', e);
    }
  }

  /*********************************
   * EXECUTE SCRIPTS (SAFE MODE)
   *********************************/
  function executeSectionScripts(section) {
    const scripts = section.querySelectorAll('script');

    scripts.forEach(script => {
      // Skip this script file and analytics/trackers
      if (
        script.src?.includes('product-sections-render') ||
        script.textContent.includes('ProductSectionsRender') ||
        script.textContent.includes('dataLayer') ||
        script.textContent.includes('_learnq') ||
        script.src?.includes('klaviyo') ||
        script.src?.includes('bazaarvoice') ||
        script.src?.includes('gtm') ||
        script.src?.includes('google')
      ) {
        return;
      }

      const newScript = document.createElement('script');

      if (script.src) {
        newScript.src = script.src;
        newScript.defer = true;
      } else {
        newScript.textContent = script.textContent;
      }

      document.body.appendChild(newScript);
      document.body.removeChild(newScript);
    });
  }

  /*********************************
   * PDP RE-INIT HOOKS
   *********************************/
  function reInitProductPage() {
    attachProductClickListener();
    processLazyImages();
    initProductSliders();
    initZoom();
    initSelectricSelects();
    initLazyLoad();
    initRecommendationsScroller();
    initPersonalization();
    initProductSelectGlobal();
    triggerVariantRadios();
    init360Spin();

    if (window.$BV) {
      try {
        $BV.ui('rr', 'refresh');
      } catch (e) {
        console.warn('Bazaarvoice refresh failed:', e);
      }
    }
  }

  /*********************************
   * PROCESS LAZY IMAGES
   *********************************/
  function processLazyImages() {
    const productSection = getProductSection();
    const shopifySection = getSectionContainer(productSection);
    const container = shopifySection || productSection || document;
    
    if (!container) return;

    const lazyImages = container.querySelectorAll(SELECTORS.lazyloadImg);
    
    lazyImages.forEach(img => {
      const dataSrc = img.getAttribute('data-src');
      const dataSrcset = img.getAttribute('data-srcset');
      const dataSizes = img.getAttribute('data-sizes');
      
      if (dataSrc) {
        img.src = dataSrc;
        img.removeAttribute('data-src');
      }
      
      if (dataSrcset) {
        img.srcset = dataSrcset;
        img.removeAttribute('data-srcset');
      }
      
      if (dataSizes) {
        img.sizes = dataSizes;
        img.removeAttribute('data-sizes');
      }
      
      img.classList.remove('lazyload');
      img.classList.add('lazyloaded', 'loaded');

      const zoomImage = img.getAttribute('data-zoom-image');
      if (!zoomImage && dataSrc) {
        img.setAttribute('data-zoom-image', dataSrc);
      }
    });

    const lazyBgElements = container.querySelectorAll(SELECTORS.lazyloadBg);
    lazyBgElements.forEach(el => {
      const bgUrl = el.getAttribute('data-bg');
      if (bgUrl) {
        el.style.backgroundImage = bgUrl;
        el.classList.remove('lazyload');
        el.classList.add('lazyloaded');
      }
    });
  }

  /*********************************
   * INIT PRODUCT SLIDERS
   *********************************/
  function initProductSliders() {
    const $ = jQuery;
    const $sliderProduct = $(SELECTORS.sliderProduct);
    const $sliderThumbs = $(SELECTORS.sliderThumbs);

    if (!$sliderProduct.length || !$sliderThumbs.length) return;
    updateThumbSliderMode($sliderThumbs);

    if ($sliderProduct.hasClass('slick-initialized')) {
      markSliderThumbsReady($sliderThumbs);
      return;
    }

    $sliderThumbs.removeClass('slider-thumbs-ready');
    $sliderThumbs.on('init.productSectionsRender', function(event, slick) {
      const $slider = slick && slick.$slider ? slick.$slider : $(event.currentTarget);
      markSliderThumbsReady($slider);
    });

    $sliderThumbs.on('setPosition.productSectionsRender afterChange.productSectionsRender', function() {
      updateAccessibilityThumbs($(this));
    });

    $sliderProduct.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      fade: true,
      draggable: false,
      asNavFor: $sliderThumbs
    });

    $sliderThumbs.slick({
      asNavFor: $sliderProduct,
      focusOnSelect: true,
      infinite: false,
      autoplay: false,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      vertical: true
    });

    $sliderProduct.on('init reInit afterChange', function() {
      initZoom();
    });

    updateAccessibilityThumbs($sliderThumbs);
  }

  /*********************************
   * MARK THUMB SLIDER READY
   *********************************/
  function markSliderThumbsReady($sliderThumbs) {
    setTimeout(() => {
      if ($sliderThumbs.hasClass('slick-initialized')) {
        $sliderThumbs.slick('setPosition');
      }

      updateAccessibilityThumbs($sliderThumbs);

      requestAnimationFrame(() => {
        updateThumbSliderMode($sliderThumbs);
        $sliderThumbs.addClass('slider-thumbs-ready');
      });
    }, 500);
  }

  /*********************************
   * UPDATE THUMB SLIDER MODE
   *********************************/
  function updateThumbSliderMode($sliderThumbs) {
    var realThumbCount = $sliderThumbs.find('.section__thumb').not('.slick-cloned .section__thumb').length;
    $sliderThumbs.toggleClass('vertical-slider-disable', realThumbCount <= 5);
  }

  /*********************************
   * UPDATE ACCESSIBILITY THUMBS
   *********************************/
  function updateAccessibilityThumbs($sliderThumbs) {
    const $ = jQuery;
    
    requestAnimationFrame(() => {
      $sliderThumbs.find('.slick-slide').each(function() {
        const $slide = $(this);
        const isHidden = $slide.attr('aria-hidden') === 'true';
        const isCloned = $slide.hasClass('slick-cloned');

        if (isHidden || isCloned) {
          $slide.find('a, button, input, [tabindex]').attr('tabindex', '-1');
        } else {
          $slide.attr('tabindex', '0').attr('role', 'button');
          $slide.find('a, button, input').removeAttr('tabindex');
        }
      });
    });
  }

  /*********************************
   * INIT ZOOM FUNCTIONALITY
   *********************************/
  function initZoom() {
    const $ = jQuery;
    const $win = $(window);
    const $sliderZoom = $(SELECTORS.sliderZoom);

    $('.zoomContainer').remove();

    if (!$sliderZoom.length) return;
    if ($win.width() < 1200) return;

    let zoomWidth = 552;
    let zoomHeight = 580;

    if ($win.width() <= 1379 && $win.width() >= 1200) {
      zoomWidth = 439;
      zoomHeight = 461;
    }

    try {
      $sliderZoom.find('.slick-active .section__image:not(.section__image--video) img').ezPlus({
        zoomType: 'window',
        zoomWindowWidth: zoomWidth,
        zoomWindowHeight: zoomHeight,
        borderSize: 0
      });
    } catch (e) {
      console.warn('Zoom initialization failed:', e);
    }
  }

  /*********************************
   * INIT SELECTRIC SELECTS
   *********************************/
  function initSelectricSelects() {
    const $ = jQuery;
    
    try {
      const productSection = getProductSection();
      const shopifySection = getSectionContainer(productSection);
      const container = shopifySection || productSection;
      
      if (!container) return;
      
      const $customSelects = $(container).find(SELECTORS.selectCustom);
      
      if ($customSelects.length && typeof $.fn.selectric === 'function') {
        $customSelects.selectric({
          disableOnMobile: false,
          nativeOnMobile: false,
          onInit: function() {
            const $wrapper = $(this).closest('.selectric-wrapper');
            if (typeof $.fn.mCustomScrollbar === 'function') {
              $wrapper.find('.selectric-scroll').mCustomScrollbar({
                axis: 'y',
                scrollInertia: 300
              });
            }
          }
        });
      }
    } catch (e) {
      console.warn('Selectric initialization failed:', e);
    }
  }

  /*********************************
   * INIT LAZYLOAD
   *********************************/
  function initLazyLoad() {
    try {
      const remainingLazyImages = document.querySelectorAll(`img${SELECTORS.lazyload}[data-src]`);
      remainingLazyImages.forEach(img => {
        const dataSrc = img.getAttribute('data-src');
        if (dataSrc && img.src === 'data:,') {
          img.src = dataSrc;
          img.classList.remove('lazyload');
          img.classList.add('lazyloaded');
        }
      });

      if (typeof LazyLoad !== 'undefined') {
        new LazyLoad({
          elements_selector: SELECTORS.lazyload
        });
      }
    } catch (e) {
      console.warn('LazyLoad initialization failed:', e);
    }
  }

  /*********************************
   * INIT RECOMMENDATIONS SCROLLER
   *********************************/
  function initRecommendationsScroller() {
    const $ = jQuery;
    
    const recommendationsSection = document.querySelector(SELECTORS.recommendations);
    if (!recommendationsSection) return;
    
    const shopifySection = getSectionContainer(recommendationsSection);
    const container = shopifySection || recommendationsSection;
    
    const $scrollContainer = $(container).find(SELECTORS.recommendationsScroller);

    if (!$scrollContainer.length) return;

    try {
      if (typeof $.fn.mCustomScrollbar === 'function') {
        if ($scrollContainer.hasClass('mCustomScrollbar')) {
          $scrollContainer.mCustomScrollbar('destroy');
        }

        $scrollContainer.mCustomScrollbar({
          axis: 'x',
          autoDraggerLength: false,
          scrollButtons: {
            enable: false
          },
          mouseWheel: {
            enable: false
          },
          advanced: {
            autoScrollOnFocus: false
          },
          callbacks: {
            whileScrolling: function() {
              updateScrollButtons($scrollContainer);
            },
            onInit: function() {
              updateScrollButtons($scrollContainer);
            }
          }
        });
      }
    } catch (e) {
      console.warn('mCustomScrollbar initialization failed:', e);
    }
  }

  /*********************************
   * UPDATE SCROLL BUTTONS
   *********************************/
  function updateScrollButtons($container) {
    const $ = jQuery;
    const $outer = $container.closest('.scroll-container-outer');
    const $prevBtn = $outer.find('.js-scroll-prev');
    const $nextBtn = $outer.find('.js-scroll-next');

    const scrollContent = $container.find('.mCSB_container');
    if (scrollContent.length) {
      const scrollLeft = parseInt(scrollContent.css('left')) || 0;
      const containerWidth = $container.find('.mCSB_container_wrapper').width() || $container.width();
      const contentWidth = scrollContent.width();

      if (scrollLeft >= 0) {
        $prevBtn.addClass('disable');
      } else {
        $prevBtn.removeClass('disable');
      }

      if (Math.abs(scrollLeft) + containerWidth >= contentWidth) {
        $nextBtn.addClass('disable');
      } else {
        $nextBtn.removeClass('disable');
      }
    }
  }

  /*********************************
   * INIT PRODUCT SELECT GLOBAL
   *********************************/
  function initProductSelectGlobal() {
    const $ = jQuery;
    
    const productSection = getProductSection();
    const shopifySection = getSectionContainer(productSection);
    const container = shopifySection || productSection;
    
    if (!container) return;
    
    const $selectGlobal = $(container).find(SELECTORS.selectGlobal);

    if (!$selectGlobal.length) return;

    const $selectedOption = $selectGlobal.find('option:selected');
    
    if ($selectedOption.length && $selectedOption.val()) {
      $selectGlobal.trigger('change');
    }
  }

  /*********************************
   * TRIGGER VARIANT RADIOS
   *********************************/
  function triggerVariantRadios() {
    const $ = jQuery;
    
    const productSection = getProductSection();
    const shopifySection = getSectionContainer(productSection);
    const container = shopifySection || productSection;
    
    if (!container) return;
    
    const $checkedInput = $(container).find(`${SELECTORS.radioColor}:checked`);
    if ($checkedInput.length) {
      setTimeout(() => {
        $checkedInput.trigger('change');
      }, 200);
    }
  }

  /*********************************
   * INIT 360 SPIN
   *********************************/
  function init360Spin() {
    if (typeof window.SPIN_360_URL !== 'undefined' && window.SPIN_360_URL) {
      const $ = jQuery;
      const $sliderProduct = $(`${SELECTORS.productWrapper} ${SELECTORS.sliderProduct}`);
      const $sliderThumbs = $(`${SELECTORS.productWrapper} ${SELECTORS.sliderThumbs}`);

      if (!$sliderProduct.length || !$sliderThumbs.length) return;

      $.ajax({
        url: window.SPIN_360_URL,
        complete: function(response) {
          if (response.status === 200) {
            const thumbHTML = '<div class="thumb thumb--video thumb--video-360 section__thumb">' +
              '<figure>' +
              '<img src="' + window.SPIN_360_ICON + '" alt="360 spin">' +
              '</figure>' +
              '</div>';
            
            $sliderThumbs.slick('slickAdd', thumbHTML);

            const productHTML = '<div>' +
              '<div class="section__image section__image--video section__image--video-360">' +
              '<figure>' +
              '<iframe src="' + window.SPIN_360_URL + '"></iframe>' +
              '</figure>' +
              '</div>' +
              '</div>';
            
            $sliderProduct.slick('slickAdd', productHTML);
            updateThumbSliderMode($sliderThumbs);
          }
        }
      });
    }
  }

  /*********************************
   * UPDATE SHOPIFY PRODUCT GLOBAL
   *********************************/
  function updateShopifyProduct(doc) {
    const scripts = doc.querySelectorAll('script');

    scripts.forEach(script => {
      const text = script.textContent || '';
      if (!text.includes('Shopify.product')) return;

      const match = text.match(/Shopify\.product\s*=\s*({[\s\S]*?});/);
      if (!match) return;

      try {
        window.Shopify = window.Shopify || {};
        window.Shopify.product = JSON.parse(match[1]);
      } catch (e) {
        console.warn('Failed to update Shopify.product:', e);
      }
    });
  }

  /*********************************
   * UPDATE 360 SPIN GLOBALS
   *********************************/
  function updateSpin360Globals(doc) {
    const scripts = doc.querySelectorAll('script');

    scripts.forEach(script => {
      const text = script.textContent || '';
      if (!text.includes('SPIN_360_URL')) return;

      const urlMatch = text.match(/window\.SPIN_360_URL\s*=\s*(["'])(.*?)\1/);
      const iconMatch = text.match(/window\.SPIN_360_ICON\s*=\s*(["'])(.*?)\1/);

      if (urlMatch) {
        window.SPIN_360_URL = urlMatch[2];
      }

      if (iconMatch) {
        window.SPIN_360_ICON = iconMatch[2];
      }
    });
  }

  /*********************************
   * INIT PERSONALIZATION
   *********************************/
  function initPersonalization() {
    if (typeof window.initPersonalizationApp === 'function') {
      window.initPersonalizationApp();
    }

    if (typeof window.initPersonalizationEnhancements === 'function') {
      window.initPersonalizationEnhancements();
    }
  }

  /*********************************
   * CLICK HANDLER
   *********************************/
  function handleClick(e) {
    const link = e.target.closest('a[href]');
    if (!link) return;

    const url = link.getAttribute('href');

    if (!url.includes('/products/')) return;

    e.preventDefault();

    const wrapper = document.querySelector(SELECTORS.groupWrapper);
    if (wrapper) {
      wrapper.querySelectorAll(SELECTORS.groupItem).forEach(item => {
        item.classList.remove('active');
      });
      link.closest(SELECTORS.groupItem)?.classList.add('active');
    }

    fetchAndReplaceSections(url);
  }

  /*********************************
   * POPSTATE (BACK/FORWARD)
   *********************************/
  window.addEventListener('popstate', e => {
    if (e.state?.url) {
      fetchAndReplaceSections(e.state.url, false);
    }
  });

  /*********************************
   * INIT
   *********************************/
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachProductClickListener);
  } else {
    attachProductClickListener();
  }

})();
